module.exports = __webpack_public_path__ + "img/konfigurasi_jadwal_pickup.681c4a4e.svg";